module.exports = __webpack_public_path__ + "static/media/bg-masthead5.573eb783.jpg";